<template>
    <div>
        <h1 class="is-size-2 is-page-title">Geschiedenis</h1>
        <p>
            Dit Belgische ras heeft een rijke geschiedenis die begint in de 19e eeuw als trekdier bij de boer en later ook in het Belgische leger.
            Echter door de toenemende mechanisatie sterft de Mâtin Belge uit in de jaren '60 en werd het stamboeknummer opgeschort. Dit was voor lange
            tijd het einde van het hondenras.
        </p>
        <br />
        <p>
            Rond de eeuwwisseling wordt er een poging ondernomen om het ras opnieuw op te bouwen, waar de vzw "De Belgische Mastiff" vanaf 2006 ook haar schouders
            onder zet. In de recente geschiedenis van het ras zien we een steeds nauwere samenwerking met de KMSH en KKUSH. Dankzij deze samenwerking is
            het mogelijk voor de vzw om aanzienlijke vooruitgang te boeken: in 2010 werd de rasstandaard goedgekeurd en de Belgische Mastiff verschijnt ook weer op het toneel
            op Europese en internationale dogshows.
        </p>
        <div class="columns is-mobile is-centered">
            <router-link to="/history" class="is-page-read-more-history">Lees meer</router-link>
        </div>
    </div>
</template>

<script>
    export default {
        name: "History"
    }
</script>

<style scoped>
    h3 {
        font-weight: 500;
        color: #016F70;
        margin-bottom: 1em;
        margin-top: 2em;
    }

    .is-page-title {
        margin-top: 0;
    }
</style>